import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withLastLocation } from 'react-router-dom-last-location';
import Skeleton from 'react-loading-skeleton';
import { useLocation } from 'react-router-dom';
import ExpandedText from '@common/helpers/expanded_text';
import { getProjectPrefix } from '@common/config/utils';
import { AdvisorPropType, AdvisorDefaultProps } from '../../../../reducers/advisor_prop_types';
import classes from './classes.module.scss';
import ReviewsSection from '../reviews_section';
import { makeMoreReadable } from '../../../../config/util';
import SomeOtherAdvisors from '../../some_other_advisors';
import { psychicsListTypes } from '../../../../config/const';
import AdvisorSpecialities from './advisor_specialities';
import { parseAndTrackAnalyticEvents } from '../../../../actions/analytics';
import AdvisorUrgencySignal from '../advisor_urgency_signal';

const descriptionContent = (title, description, needAddItemProp) => (
  <div className={ classes.descriptionHolder }>
    {title}
    <span className={ classes.description } itemProp={ needAddItemProp ? 'description' : '' }>
      {makeMoreReadable(description) || <Skeleton count={ 4 } height={ 17 } />}
    </span>
  </div>
);

const reviewsContent = (id) => (!id  ? null : (
  <ReviewsSection id={ id } />
));

const specialitiesContent = (specialities, advisorId, loading) => (
  <AdvisorSpecialities specialities={ specialities } advisorId={ advisorId } loading={ loading } />
);

const renderNoAavailableForPG = (liveModes, t, loading, location) => {
  const advisorAvalibalForPG = liveModes.find((item) => item.modeState !== 'disabled');
  if (liveModes.length > 0 && !advisorAvalibalForPG && typeof (loading) !== 'undefined' && !loading) {
    return (
      <SomeOtherAdvisors
        theme={ psychicsListTypes.NOTAVAILABLEFORPG }
        title={ t('notAvailableForPg.sorry_this_advisor_is_not_available_for_live_readings_now') }
        subTitle={ t('notAvailableForPg.here_are_some_other_advisors_who_may_interest_you') }
        location={ location }
      />
    );
  }
  return null;
};

function AdvisorMainContent({
  serviceDescription, aboutMe, specialities, id, t, liveModes, loading, aiReviewsSummary, nickname, status
}) {
  const location = useLocation();
  const [isShowMoreClicked, setIsShowMoreClicked] = useState(false);
  const currentTime = new Date();

  const onSummaryExpand = (e, isShowMore) => {
    e.preventDefault();
    if (!isShowMore && !isShowMoreClicked) {
      const analyticsParams = {
        'advisor id': id,
        'advisor name': nickname,
        'customer id': window.currentUserId,
        'time to click': Math.round((new Date().getTime() - currentTime.getTime()) / 1000)
      };

      setIsShowMoreClicked(true);
      parseAndTrackAnalyticEvents({
        'ai reviews summary clicked': analyticsParams
      });
    }
  };

  const renderAISummary = () => {
    const { title, description } = aiReviewsSummary;
    return (
      <div className={ classes.aiSummaryContainer } style={ { backgroundImage: `url(${ require(`../../img/${ getProjectPrefix() }_ai_summary_background_icon.svg`) })` } }>
        <div className={ classes.summaryTitle }>{ title }</div>
        <ExpandedText
          className={ classes.summaryContent }
          limit={ 125 }
          readMoreKind="limitTextByChars"
          readMoreClick={ onSummaryExpand }
          text={ description }
          buttonOptions={ {
            moreText: t('advisorProfile.show_more'),
            lessText: t('advisorProfile.show_less')
          } }
        />
      </div>
    );
  };

  return (
    <div className={ classes.container }>
      <AdvisorUrgencySignal advisorId={ id } isOnline={ status === 'online' } type="advisor_content" loading={ loading } />
      <div className={ classes.contentContainer }>
        {aiReviewsSummary && renderAISummary()}
        {descriptionContent(t('advisorProfile.about_my_services'), serviceDescription, true)}
        {descriptionContent(t('advisorProfile.about_me'), aboutMe)}
        {specialitiesContent(specialities, id, loading)}
        {renderNoAavailableForPG(liveModes, t, loading, location)}
        {reviewsContent(id)}
      </div>
    </div>
  );
}

AdvisorMainContent.propTypes = {
  ...AdvisorPropType,
  t: PropTypes.func.isRequired
};

AdvisorMainContent.defaultProps = {
  ...AdvisorDefaultProps
};

export default withLastLocation(AdvisorMainContent);
